module.exports = __webpack_public_path__ + "media/images/front/sns/youtube_logo-f3f9a1ce0d753b1319549fea47cefcaf.png";